import React, { useState } from "react";
import styles from "@/styles/desktop/InfoWithImageSection.module.scss";
import DropdownComponent from "../DropdownComponent";
import { InfoWithImageSectionProps } from "@/app/interface/components";
import CustomLink from "../CustomLink";
import ImageComponentHeightFixed from "../ImageComponentHeightFixed";

const InfoWithImageSectionDesktop: React.FC<InfoWithImageSectionProps> = ({
	href,
	justifyContent,
	isIntro,
	hasButton,
	isDropdown,
	title,
	text,
	img,
	contentDropdown,
	flexDirection,
	loading,
	imgHeightFixed,
	width,
	height,
}) => {
	const [openDropdownIndex, setOpenDropdownIndex] = useState<number | null>(
		null
	);

	const handleDropdownToggle = (index: number) => {
		setOpenDropdownIndex((prevIndex) => (prevIndex === index ? null : index));
	};

	return imgHeightFixed ? (
		<section
			className={styles.mainFix}
			style={{ flexDirection: flexDirection }}
		>
			<div
				className={styles.contentFix}
				style={{ justifyContent: justifyContent }}
			>
				<div style={{ width: 540 }}>
					{isIntro ? <h1>{title}</h1> : <h2 className="h2-medium">{title}</h2>}
					{isDropdown ? (
						<div>
							{contentDropdown!.map((content, index) => (
								<DropdownComponent
									key={index}
									title={content.title}
									text={content.text}
									isOpen={openDropdownIndex === index}
									onToggle={() => handleDropdownToggle(index)}
								/>
							))}
						</div>
					) : (
						<>
							<p>{text}</p>
							{hasButton && (
								<div className={styles.btn}>
									<CustomLink className="btn-secondary" href={href!}>
										Faça uma cotação
									</CustomLink>
								</div>
							)}
						</>
					)}
				</div>
			</div>
			<ImageComponentHeightFixed
				src={img}
				alt=""
				loading={loading}
				width={width}
				height={height}
			/>
		</section>
	) : (
		<section className={styles.main} style={{ flexDirection: flexDirection }}>
			<div className={styles.content}>
				{isIntro ? <h1>{title}</h1> : <h2 className="h2-medium">{title}</h2>}
				{isDropdown ? (
					<div>
						{contentDropdown!.map((content, index) => (
							<DropdownComponent
								key={index}
								title={content.title}
								text={content.text}
								isOpen={openDropdownIndex === index}
								onToggle={() => handleDropdownToggle(index)}
							/>
						))}
					</div>
				) : (
					<>
						<p>{text}</p>
						{hasButton && (
							<div className={styles.btn}>
								<CustomLink className="btn-secondary" href={href!}>
									Faça uma cotação
								</CustomLink>
							</div>
						)}
					</>
				)}
			</div>
			<img src={img} alt="" loading={loading} width={width} height={height} />
		</section>
	);
};

export default React.memo(InfoWithImageSectionDesktop);
